/* eslint-disable no-console, no-confusing-arrow */
const filterLists = {
  designStyleFilter: [],
  roomTypeFilter: [],
  productLineFilter: [],
  colorRangeFilter: [],
  imagesVideosFilter: [],
};

const formatToKebobCase = str => (
  str.toLowerCase().replace(/\s/gi, '-').replace(/&/gi, 'and')
);

const filters = {
  designStyleFilter: {
    name: 'Design Style',
    order: 3,
    active: true,
    options: [],
  },
  roomTypeFilter: {
    name: 'Room Type',
    order: 4,
    active: true,
    options: [],
  },
  imagesVideosFilter: {
    name: 'Images Or Videos',
    order: 1,
    active: false,
    options: [],
  },
  productLineFilter: {
    name: 'Product',
    order: 2,
    active: true,
    options: [],
  },
  colorRangeFilter: {
    name: 'Color',
    order: 5,
    active: true,
    options: [],
  },
};

const addFilterItemByName = (name, filterType, inputType) => (
  {
    type: inputType,
    id: `${formatToKebobCase(filterType)}-option-${formatToKebobCase(name)}`,
    name,
    inputName: `${formatToKebobCase(filterType)}-option-${formatToKebobCase(name)}`,
    value: name,
    image: '',
    isChecked: false,
  }
);

const addItemToList = (names, filterType, list, inputType) => {
  const filterList = filterLists[list];
  // "names" is a comma separated string, there could be more than one option/name
  const arr = names.split(',').map(name => name.trim());
  arr.forEach((name) => {
    if (filterList.indexOf(name) === -1 && name !== '') {
      filterList.push(name);
      filters[list].options.push(addFilterItemByName(name, filterType, inputType));
    }
  });
};

const buildFilterObjects = (data) => {
  data.forEach((item) => {
    addItemToList(item.designStyle, 'Design Style', 'designStyleFilter', 'checkbox');
    addItemToList(item.roomType, 'Room Type', 'roomTypeFilter', 'checkbox');
    addItemToList(item.productLineName, 'Product', 'productLineFilter', 'checkbox');
    addItemToList(item.colorRange, 'Color', 'colorRangeFilter', 'checkbox');
    addItemToList(item.type, 'Images Videos', 'imagesVideosFilter', 'radio');
  });
  // Hardcode plurals
  filters.imagesVideosFilter.options.forEach((item) => {
    if (item.name === 'Image') {
      item.name = 'Images';
    }
    if (item.name === 'Video') {
      item.name = 'Videos';
    }
  });
};

const getWidenGalleryFilterData = (data) => {
  buildFilterObjects(data);
  filters.designStyleFilter.options.sort((a, b) => (a.name > b.name) ? 1 : -1);
  filters.roomTypeFilter.options.sort((a, b) => (a.name > b.name) ? 1 : -1);
  filters.productLineFilter.options.sort((a, b) => (a.name > b.name) ? 1 : -1);
  filters.colorRangeFilter.options.sort((a, b) => (a.name > b.name) ? 1 : -1);
  filters.imagesVideosFilter.options.sort((a, b) => (a.name > b.name) ? 1 : -1);
  return filters;
};

export default getWidenGalleryFilterData;
/* eslint-enable no-console, no-confusing-arrow */
